module.exports = __webpack_public_path__ + "img/Group 52.ee4d639b.png";